import { deprecated } from 'typesafe-actions'
import { Result, IAppError } from '../../interfaces/base'
import { User } from '../../interfaces/entities/user'

const { createAction } = deprecated

export const getUser = createAction('user/GET', (resolve) => {
  return () => resolve()
})

export const getUserComplete = createAction('user/GET_COMPLETE', (resolve) => {
  return (response: Result<User, IAppError>) => resolve(response)
})
